import { AfterViewInit, Component, OnDestroy, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";

import { Observable, Subject } from "rxjs";
import { map, startWith, takeUntil } from "rxjs/operators";

import { RepriceListItem } from "src/app/models/priceyard.model";
import { PriceyardSkuGridConfigService } from "../../data-grid/priceyard-sku-grid-config.service";

@Component({
  selector: "app-repricing-model-cell-editor",
  templateUrl: "./repricing-model-cell-editor.component.html",
  styleUrls: ["./repricing-model-cell-editor.component.scss"],
})
export class RepricingModelCellEditorComponent
  implements OnDestroy, AfterViewInit {
  models: any;
  constructor(
    private priceyardSkuGridConfigService: PriceyardSkuGridConfigService
  ) {
    this.displayWith = this.displayWith.bind(this);
  }
  editModel = true;
  params: any;
  myControl = new FormControl();
  filteredOptions$: Observable<any[]>;
  options: any;
  saveData = false;
  private destroy$ = new Subject<void>();
  @ViewChild("mySelect") mySelect;

  agInit(params: any): void {
    this.params = params;
    this.options = this.priceyardSkuGridConfigService.options.filter(
      (model: RepriceListItem) => model.marketPlace === params.data.AccountType
    );
    this.models = Object.assign([], this.options)
    this.filteredOptions$ = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );
    const myModel = this.params.data.Prmodel;
    this.myControl.setValue(myModel);
  }

  ngAfterViewInit() {
    // this.mySelect.open();
  }

  private _filter(value) {    
    if (value) {
      if (!isNaN(Number(value))) {
        const modelById = this.models.find(option => option.modelId === Number(value));
        return modelById ? [modelById] : [];
      } else {
        const filterValue = value?.toLowerCase();
        return this.models.filter(option => option.name?.toLowerCase().includes(filterValue));
      }
    } else {
      return this.models;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  getValue() {
    if (this.myControl.value) {
      const modal = this.options.find(
        (model) => model.modelId === +this.myControl.value
      );
      const data = {
        ...this.params.data,
        PriceModelName: modal.name,
      };
      if (this.saveData) {
        this.params.node.setData(data);
        this.saveData = false;
        return +this.myControl.value;
      }
      return +this.params.data.Prmodel;
      // rowNode.setDataValue()
    } else {
      return null;
    }
  }

  displayWith(value: any): string  {
    if(value){
      if (!isNaN(Number(value))) {
        const modelById = this.models.find(option => option.modelId === Number(value));
        return modelById.name;
      }
      else {
        return value?.name || value;
      }
    }
  }

  save(event: MouseEvent) {
    this.saveData = true;
    this.params.stopEditing();    
    event?.stopPropagation();
  }

  removeModel() {
    this.saveData = false;
    this.myControl.reset();
    this.params.stopEditing();
  }

  toggleSkuPricingModel(isActive) {
    this.params.data.Prmodel.isActive = !isActive;
    this.params.stopEditing();
  }

  prevent(event: MouseEvent){
    event?.stopPropagation();
  }
}
